export default __webpack_public_path__ + "static/media/net_sides_bg.755a5c2c.svg";